module.exports = __webpack_public_path__ + "static/media/control.e79408f6.png";